//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import TaskDocumentsBody from './TaskDocumentsBody.vue'

export default {
  components: {
    TaskDocumentsBody
  },
  data: function () {
    return {
      thumbStyle: {
        right: '2px',
        borderRadius: '7px',
        backgroundColor: '#A9A9A9',
        width: '8px',
        opacity: 0.75
      },
      barStyle: {
        right: '0px',
        borderRadius: '9px',
        backgroundColor: '#A9A9A9',
        width: '12px',
        opacity: 0.2
      }
    }
  },
  beforeRouteLeave (to, from, next) {
    if (this.$refs.taskDocumentsBody) {
      return this.$refs.taskDocumentsBody.beforeRouteLeaveMethod(to, from, next)
    }
  },
  computed: {
    docsHeaderFixed: function () {
      return this.$store.getters.getUserSetting('ui.common.docsHeaderFixed', true)
    }
  }
}

